<template>
  <v-card class="overflow-hidden" color="primary">
    <v-app-bar color="primary" app rounded="0" clipped-left elevate-on-scroll>
      <v-app-bar-nav-icon
        v-if="authenticated || (!isPublicPlayerPage && isPublicPlayerPage)"
        @click="drawer = !drawer"
        color="white"
      ></v-app-bar-nav-icon>
      <LogoLink
        v-if="(isPublicPlayerPage || isLiveVideo) && !loadingCustomBrandFirstLoad"
        path="/"
        :src="currentLogo"
        alt="logo"
        :disabledRedirect="isPublicPlayerPage || isLiveVideo"
      />
      <LogoLink v-else-if="!isPublicPlayerPage && !isLiveVideo" path="/" :src="nextlaneLogo" alt="logo" />
    </v-app-bar>
    <v-navigation-drawer color="primary" theme v-model="drawer" app clipped disable-resize-watcher>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
          <div v-if="authenticated">
            <MenuLink :path="stampothequeUri + '/shootings'" :name="translate.shootings" icon="collections" />
            <MenuLink :path="statisticUri + '/'" :name="translate.statistics" icon="assessment" />
            <MenuLink
              v-if="hasManageUsersAccess && isUserV2Access"
              :path="billytUri + '/users'"
              :name="translate.userboard"
              icon="supervised_user_circle"
            />
            <MenuLink v-if="hasStampytAccess" :path="DMSUri" :name="translate.dms" icon="dashboard" />
            <MenuLink
              v-if="accessVideoLive"
              :path="stampothequeUri + '/videos/live/rooms'"
              :name="translate.meeting"
              icon="video_label"
            />
            <MenuLink
              v-if="accessAdminVideo"
              :path="stampothequeUri + '/adminvideos'"
              :name="translate.videos"
              icon="videocam"
            />
            <MenuLink v-if="accessCashBuyBack" :path="cashbuybackUri" :name="translate.cashbuyback" icon="build" />
            <MenuLink v-if="hasDemoAcces" :path="billytUri + '/demo'" :name="translate.demo" icon="book" />
            <MenuLink :path="billytUri + '/faq'" :name="translate.faq" icon="question_answer" />
            <MenuLink :path="billytUri + '/tutorials'" :name="translate.tutorials" icon="video_library" />
            <MenuLink v-if="isUserV2Access" :path="billytUri + '/account'" :name="translate.account" icon="person" />
            <MenuLink v-if="hasStampytAccess" :path="settingUri" :name="translate.settings" icon="settings" />
          </div>
          <div>
            <MenuLinkAction
              v-if="hasKeycloak"
              :action="!authenticated ? login : logout"
              :name="!authenticated ? translate.login : translate.logout"
              icon="exit_to_app"
            />
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import LogoLink from './LogoLink.vue'
import MenuLink from './MenuLink.vue'
import MenuLinkAction from './MenuLinkAction.vue'

import { isUserAdminV2 } from '@/utils'

import { mapState } from 'vuex'

export default {
  name: 'Header',

  components: {
    MenuLink,
    MenuLinkAction,
    LogoLink
  },

  props: {
    userOptions: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    drawer: false,
    group: null
  }),

  computed: {
    ...mapState({
      customBrand: state => state.customBrand,
      loadingCustomBrandFirstLoad: state => state.loadingCustomBrandFirstLoad
    }),
    stampothequeUri() {
      return window.env.STAMPOTHEQUE_URI
    },
    settingUri() {
      return window.env.SETTING_URI
    },
    billytUri() {
      return window.env.CLOUD_URL
    },
    statisticUri() {
      return window.env.STATISTIC_URI
    },
    DMSUri() {
      return window.env.DMS_URI
    },
    cashbuybackUri() {
      return window.env.CASHBUYBACK_URI
    },
    translate() {
      return this.$t('header')
    },
    hasKeycloak() {
      return this.$keycloak
    },
    hasDemoAcces() {
      const acceptedAccess = ['stampyt_admin', 'stampyt_csm', 'stampyt_sales']
      const userHabilitations = this.$store.state.user.habilitations

      return userHabilitations.some(r => acceptedAccess.includes(r))
    },
    authenticated() {
      return this.$keycloak && this.$keycloak.authenticated
    },
    accessVideoLive() {
      const useVideoAccess = this.userOptions && this.userOptions.find(el => el.name === 'useVideoLive')

      return (useVideoAccess && useVideoAccess.value) || false
    },
    accessAdminVideo() {
      const useVideoAccess = this.userOptions && this.userOptions.find(el => el.name === 'useAdminVideo')

      return (useVideoAccess && useVideoAccess.value) || false
    },
    accessCashBuyBack() {
      const useVideoAccess = this.userOptions && this.userOptions.find(el => el.name === 'vehicleIdentificationMethods')

      return (useVideoAccess && useVideoAccess.value.length > 0) || false
    },
    hasStampytAccess() {
      if (!this.authenticated) return false

      const habilitations = this.$keycloak.tokenParsed.habilitations

      return habilitations.some(el => el === 'stampyt_admin' || el === 'stampyt_csm')
    },
    hasManageUsersAccess() {
      if (!this.authenticated) return false

      const token = this.$keycloak.tokenParsed
      const roles = token.roles

      return roles && roles.some(el => el === 'manage-users')
    },
    isUserV2Access() {
      if (!this.authenticated) return false

      const token = this.$keycloak.tokenParsed
      const hasAccess = !isUserAdminV2(token)

      return hasAccess
    },
    isPublicPlayerPage() {
      return this.$route.name === 'PublicPlayer'
    },
    isLiveVideo() {
      return this.$route.name === 'LiveVideoCall'
    },
    nextlaneLogo() {
      return require('@/assets/nextlane_logo_white.png')
    },
    currentLogo() {
      if (this.customBrand && this.customBrand !== '') return this.customBrand
      else return this.nextlaneLogo
    }
  },

  methods: {
    logout() {
      this.$keycloak && this.$keycloak.logoutFn()
    },

    login() {
      this.$keycloak && this.$keycloak.loginFn()
    }
  }
}
</script>
